// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const UnresolvedIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m15.74 8.39-2.77-1.6c-.35-.2-.59-.03-.59.35v.94q-2.33.17-3.67 1.6l-.03.03V5.2h.9c.38 0 .52-.28.34-.6l-1.6-2.77c-.16-.34-.51-.34-.68 0l-1.6 2.77c-.17.35-.03.6.35.6h.93v4.46l-.03-.03a5.4 5.4 0 0 0-3.67-1.6v-.93c0-.38-.28-.56-.59-.35L.26 8.36c-.35.17-.35.51 0 .69l2.77 1.59c.35.17.59.03.59-.35v-.86q1.7.15 2.63 1.14c.76.8 1.04 1.84 1.04 2.5v.69c.03.34.31.62.7.66h.03c.34 0 .66-.28.69-.66 0-.04-.03-.31 0-.7 0-.65.28-1.7 1.04-2.49a4 4 0 0 1 2.63-1.14v.86c0 .38.28.52.59.35l2.77-1.6c.35-.17.35-.48 0-.65"
    />
  </svg>,
  "Unresolved",
);
export default UnresolvedIcon;
